<div>
  <button [ngClass]="{'sync-fixed': addSyncFixed}" class="btn btn-nc float-right" 
          (click)="baseButtonClick()" >
    {{ buttonLabel }}
    <i [class]="commit_btn_spinner"></i>
  </button>
  <button *ngIf="showCancelButton" [ngClass]="{'sync-fixed': addSyncFixed}"
          (click)="cancelButtonClick()"
          class="btn cancel-btn">
    CANCEL
  </button>
</div>

